import { Autocomplete, TextField } from "@mui/material";

// Filter dropdown for list pages. Options are { value, label }; clearing the field means "All" and reports "".
const FilterAutocomplete = ({ options, value, onChange, label, noOptionsText, placeholder, disableClearable }) => {
    return (<Autocomplete
        fullWidth
        disableClearable={disableClearable}
        options={options || []}
        value={(options || []).find(item => item?.value === value) || null}
        getOptionLabel={(option) => option?.label || ""}
        isOptionEqualToValue={(option, selected) => option?.value === selected?.value}
        noOptionsText={noOptionsText || "No options"}
        onChange={(event, newValue) => onChange(newValue ? newValue.value : "")}
        renderInput={(params) => (<TextField {...params} label={label} placeholder={placeholder} />)}
    />);
};

export default FilterAutocomplete;
